<div [class.writeable]="!isReadOnly">
	<span *ngFor="let i of [ 0, 1, 2, 3, 4 ]">
		<i *ngIf="rating > i" class="fa-sharp fa-solid fa-star" (click)="setRating(i + 1)"></i>
		<i *ngIf="rating <= i" class="fa-sharp fa-regular fa-star" (click)="setRating(i + 1)"></i>
	</span>
  </div>